import React from 'react';

const Error = () => {
    return (
        <div>
            <h1>Error in fetching JSON data</h1>
        </div>
    );
};

export default Error;